import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiServiceBase } from '../../base/api-service-base';
import { AuthService } from '../../authentication/auth.service';
import { PaymentStatusReferenceModel } from '../../models/reference-model/reference-general-model';

@Injectable({
    providedIn: 'root'
})
export class PaymentStatusReferenceService extends ApiServiceBase {
    private readonly PATH = "/system/PaymentStatusReferences"

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getPaymentStatusReference(): Observable<PaymentStatusReferenceModel[]> {
        return this.httpGet<PaymentStatusReferenceModel[]>(this.PATH, null)
        .pipe(
            map(res => res.body)
        )
    }
}